import '.ac{position:relative;}.ssr-plugin'
import '.l4{width:64px;}.ssr-plugin'
import '.l5{height:64px;}.ssr-plugin'
import '.af{flex-shrink:0;}.ssr-plugin'
import '.be{position:absolute;}.ssr-plugin'
import '.l6{bottom:-4px;}.ssr-plugin'
import '.j3{right:-4px;}.ssr-plugin'
import '.gp{border-radius:50%;}.ssr-plugin'
import '.ci{border:2px solid var(--palette-white);}.ssr-plugin'
import '.c2{overflow:hidden;}.ssr-plugin'
import '.l7{width:32px;}.ssr-plugin'
import '.l8{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="ac l4 l5 af"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="be l6 j3 gp ci c2 l7 l8"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
